// extracted by mini-css-extract-plugin
export var notificationHost = "_lv-0";